import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DropDownItem } from "../../pojo/DropDownItem";
import { ServerSidePagination } from "../../pojo/ServerSidePagination";
import { BaseControlValueAccessor } from "../reactive-forms-control-value-accessor/base.control.value.accessor.directive";

@Component({
    template: "",
    standalone: false,
})
export class S25DropdownAbstract extends BaseControlValueAccessor<DropDownItem> {
    @Input() staticItems?: DropDownItem[];
    @Input() chosen: DropDownItem;
    @Input() onSelect: Function;
    @Input() searchEnabled?: boolean;
    @Input() hasFav: boolean;
    @Input() autoOpen?: boolean;
    @Input() focusFirst?: boolean;
    @Input() alwaysOpen?: boolean;
    @Input() hideSearch?: boolean;
    @Input() apiBean?: any;
    @Input() serverSide?: ServerSidePagination; //only used for "expensive" search components (event, location, resource, org, contact, etc)
    @Input() resetSelectedOnCleanup: boolean;
    @Input() useSecurity?: boolean; //only used for master defn dropdowns
    @Input() activeOnly?: boolean; //only used for master defn dropdowns
    @Input() omitReadOnly?: boolean; //search criteria with 'tags' enabled might have a 'read only' option
    @Input() onLoad?: Function;
    @Input() customFilterValue: string;
    @Input() ariaLabel?: string;
    @Input() noSelection?: string; // Show this message instead of the chosen item
    @Input() filter: (item: DropDownItem) => boolean;
    @Input() emptyText: string;
    @Input() hasNoneItem: boolean = false;
    @Input() noneItemLabel: string = "None";
    @Input() scrollIntoView: boolean;
    @Input() readOnly: boolean;
    @Input() blockDetailsNav: boolean = false; // intentionally block ability to navigate to object details without OLS override in s25-item

    @Output() chosenChange = new EventEmitter<DropDownItem>();

    items: DropDownItem[];

    onChosenChange(data: any) {
        this.onTouched();
        this.onValChange(data);
        this.chosenChange.emit(data);
    }

    onWriteValue(value: DropDownItem) {
        this.chosen = value;
    }
}
